import {
  Box,
  Stack,
  type SxProps,
  type Theme,
  Typography,
} from '@mui/material';
import { AlertTriangle } from 'lucide-react';

import { warningAlertColors } from '@shared/theme/StyleProvider';

type WarningAlertProps = {
  title: React.ReactNode;
  children?: React.ReactNode;
  sx?: SxProps<Theme>;
};

export const WarningAlert = ({ title, children, sx }: WarningAlertProps) => (
  <Box
    role="alert"
    sx={{
      borderRadius: '8px',
      border: '1px solid',
      borderColor: 'warning.light',
      bgcolor: warningAlertColors.bg,
      px: 2,
      py: 1.5,
      ...sx,
    }}
  >
    <Stack
      direction="row"
      sx={{
        gap: 1.5,
        alignItems: 'flex-start',
      }}
    >
      <Box sx={{ display: 'flex', mt: 0.25, flexShrink: 0 }}>
        <AlertTriangle size={16} color={warningAlertColors.icon} />
      </Box>
      <Box sx={{ color: warningAlertColors.text }}>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 600,
            color: 'inherit',
          }}
        >
          {title}
        </Typography>
        {children}
      </Box>
    </Stack>
  </Box>
);
